var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 32,
    viewBox: "0 0 8 32",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 23.953q1.591 0 2.807 1.216t1.216 2.807-1.216 2.807-2.807 1.216-2.807-1.216-1.216-2.807 1.216-2.807 2.807-1.216zM4 11.977q1.591 0 2.807 1.216t1.216 2.807-1.216 2.807-2.807 1.216-2.807-1.216-1.216-2.807 1.216-2.807 2.807-1.216zM4 8.047q-1.591 0-2.807-1.216t-1.216-2.807 1.216-2.807 2.807-1.216 2.807 1.216 1.216 2.807-1.216 2.807-2.807 1.216z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/icon-menu.0a6c3fa3739757f3b15fd210f55b71d3.svg";
export { ForwardRef as ReactComponent };